import { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";

const FounderStoryAdmin = () => {
  const [form, setForm] = useState({
    title: "",
    content: [""],
    founderName: "",
    founderImage: "",
    foundedYear: "",
    experienceYears: "",
    interviewsConducted: ""
  });

  useEffect(() => {
    api.get("/api/our-story/our-story").then(res => {
      if (res.data) setForm(res.data);
    });
  }, []);

  const save = async () => {
    await api.post("/api/our-story/our-story", form);
    alert("Founder story updated");
  };

  return (
    <div className="max-w-4xl space-y-6">
      <h1 className="text-2xl font-bold">Founder Story</h1>

      <div>
        <label className="font-medium">Title</label>
        <input
          className="w-full border p-2"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
        />
      </div>

      <div>
        <label className="font-medium">Story Paragraphs</label>
        {form.content.map((p, i) => (
          <textarea
            key={i}
            className="w-full border p-2 mb-2"
            value={p}
            onChange={(e) => {
              const copy = [...form.content];
              copy[i] = e.target.value;
              setForm({ ...form, content: copy });
            }}
          />
        ))}
        <button
          onClick={() =>
            setForm({ ...form, content: [...form.content, ""] })
          }
          className="text-blue-600 text-sm"
        >
          + Add paragraph
        </button>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <input placeholder="Founder Name" className="border p-2"
          value={form.founderName}
          onChange={e => setForm({ ...form, founderName: e.target.value })}
        />
        <input placeholder="Founder Image URL" className="border p-2"
          value={form.founderImage}
          onChange={e => setForm({ ...form, founderImage: e.target.value })}
        />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <input placeholder="Founded Year" className="border p-2"
          value={form.foundedYear}
          onChange={e => setForm({ ...form, foundedYear: e.target.value })}
        />
        <input placeholder="Experience Years" className="border p-2"
          value={form.experienceYears}
          onChange={e => setForm({ ...form, experienceYears: e.target.value })}
        />
        <input placeholder="Interviews Conducted" className="border p-2"
          value={form.interviewsConducted}
          onChange={e => setForm({ ...form, interviewsConducted: e.target.value })}
        />
      </div>

      <button
        onClick={save}
        className="bg-green-600 text-white px-4 py-2 rounded"
      >
        Save Founder Story
      </button>
    </div>
  );
};

export default FounderStoryAdmin;
